export default {
  "trigger": "Registrar por voz",
  "examplesButton": "¿Qué puedo decir?",
  "example": "«{first} uno sobre par, {second} birdie»",
  "title": "RESULTADOS POR VOZ",
  "states": {
    "requesting_permission": "Preparando el micrófono…",
    "listening": "Escuchando…",
    "processing_recording": "Procesando la grabación…",
    "transcribing": "Transcribiendo…",
    "interpreting": "Interpretando tus resultados…",
    "review": "Revisa estos resultados",
    "error": "Resultados por voz"
  },
  "cancel": "Cancelar",
  "done": "Listo",
  "heard": "Hemos oído: «{transcript}»",
  "strokes": "golpes",
  "decrease": "Reducir los golpes propuestos de {name}",
  "increase": "Aumentar los golpes propuestos de {name}",
  "labels": {
    "holeInOne": "Hoyo en uno",
    "albatross": "Albatros",
    "eagle": "Eagle",
    "birdie": "Birdie",
    "par": "Par",
    "bogey": "Bogey",
    "doubleBogey": "Doble bogey",
    "tripleBogey": "Triple bogey"
  },
  "correction": "Corrección escuchada: «{phrase}»",
  "repair": "Confirma la interpretación: «{original}» se ha interpretado como «{replacement}».",
  "repairSuggestion": "Posible interpretación: «{original}» puede significar «{replacement}». Confirma los golpes reales abajo.",
  "subset": "Solo se aplicarán los resultados comprendidos. Las entradas sin resolver no se guardarán.",
  "retry": "Intentar de nuevo",
  "apply": "Aplicar resultados",
  "applySubset": "Aplicar resultados comprendidos",
  "manual": "Registrar manualmente",
  "clarification": "Necesita aclaración",
  "player": "Jugador",
  "choosePlayer": "Elige un jugador",
  "gross": "Golpes brutos",
  "confirmEntry": "Confirmar este resultado",
  "skip": "Omitir esta entrada",
  "errors": {
    "interpretationFailure": "No hemos podido interpretar los resultados. Inténtalo de nuevo o regístralos manualmente.",
    "unavailable": "El registro por voz no está disponible ahora. Registra los resultados manualmente.",
    "microphone_permission_denied": "Privana no tiene acceso al micrófono. Activa el micrófono para Privana en los ajustes del dispositivo e inténtalo de nuevo.",
    "microphone_unavailable": "No hemos podido acceder al micrófono. Inténtalo de nuevo.",
    "media_recorder_unavailable": "Este dispositivo no admite grabación de voz.",
    "empty_audio": "No hemos captado ningún audio.",
    "unsupported_audio": "El formato de audio de este dispositivo no es compatible.",
    "upload_failed": "No hemos podido enviar la grabación. Comprueba la conexión e inténtalo de nuevo.",
    "no_speech": "No hemos captado ninguna voz.",
    "transcription_failed": "No hemos podido transcribirlo. Inténtalo de nuevo.",
    "voice_timeout": "El registro por voz ha tardado demasiado. Inténtalo de nuevo o registra manualmente.",
    "recording_failed": "No hemos podido grabar tu voz. Inténtalo de nuevo.",
    "saveFailure": "No se han podido poner algunos resultados en cola. Mantén esta revisión abierta e inténtalo de nuevo."
  }
}
